var generateStyle = function generateStyle(componentTheme) {
  return {
    wordLimitInputsContainer: {
      marginBottom: 0,
      display: 'flex',
      marginTop: componentTheme.wordLimitInputsContainerMarginTop,
      marginLeft: componentTheme.wordLimitInputContainerMarginLeft
    },
    wordLimitInput: {
      paddingRight: componentTheme.wordLimitInputPadding
    }
  };
};
export default generateStyle;